import { EditView, General, I18nType, InitialView } from "../services";
/**
 * Replaces all placeholders with the given pattern in a i18nType (JSON) object with text snippets with corresponding identifiers from "replacementTexts"
 * Example usage: `newTexts = replaceAllPlaceholdersWithText(content, [content.general, content.initialView])`
 * @param inputText I18nObject or string with input texts (containing placeholders, that shall be replaced)
 * @param replacementsTexts Array of Objects that contain key:value pairs (with the values being strings) or a combination of EditView, InitialView and General (from i18nType), which are in fact also Object with key:value pairs (but can not simply be converted!?).
 * @param placeholderPattern String with a pattern that can be used as a RegEx. Default is alphabetic + "." ([A-Za-z.]*) for JSON/Object properties, enclosed by percentage signs.
 * @return Object with i18nType
 */
export function replaceAllPlaceholdersWithText(
	inputTexts: I18nType,
	replacementsTexts: Array<{ [key: string]: string }> | Array<General | InitialView | EditView>,
	placeholderPattern: string = `(%[A-Za-z\.]*%)`,
): I18nType {
	let workingCopy = JSON.stringify(inputTexts);
	workingCopy = replaceAllPlaceholdersInString(workingCopy, replacementsTexts, placeholderPattern);

	return JSON.parse(workingCopy);
}

/**
 * Replaces all placeholders with the given pattern in a string with text snippets with corresponding identifiers from "replacementTexts"
 * Example usage: `replaceAllPlaceholdersWithText("La %thankYou% Lu", [{bla: "blubb", muh: "mäh"}, {thankYou: "Le"}]))`. Result: "La le Lu"
 * @param inputText I18nObject or string with input texts (containing placeholders, that shall be replaced)
 * @param replacementsTexts Array of Objects that contain key:value pairs (with the values being strings) or a combination of EditView, InitialView and General (from i18nType), which are in fact also Object with key:value pairs (but can not simply be converted!?).
 * @param placeholderPattern String with a pattern that can be used as a RegEx. Default is alphabetic + "." ([A-Za-z.]*) for JSON/Object properties, enclosed by percentage signs.
 * @return String "inputText" with placeholders replaced
 */
export function replaceAllPlaceholdersInString(
	inputText: string,
	replacementsTexts: Array<{ [key: string]: string }> | Array<General | InitialView | EditView>,
	placeholderPattern: string = `(%[A-Za-z\.]*%)`,
): string {
	const regex: RegExp = new RegExp(placeholderPattern, "g");
	// If "match" returns null (no matches), assign empty array, so "for" can iterate (to avoid additional if-statement).
	let allPlaceholders = inputText.match(regex) || [];
	for (const placeholder of allPlaceholders) {
		let placeholderWithoutMarker = placeholder.replaceAll("%", "");
		let replaceTextFragment = "[string not found]";
		for (let lib of replacementsTexts) {
			if (lib[placeholderWithoutMarker]) {
				replaceTextFragment = lib[placeholderWithoutMarker];
			}
		}
		inputText = inputText.replace(placeholder, replaceTextFragment);
	}

	return inputText;
}
